export * from './dateFormat'
export * from './downloadFile'
export * from './formatErrors'
export * from './mock'
export * from './translate'
export * from './zodExtensions'
export * from './textFormatting'
export * from './sampleAction'
export * from './inputHelper'

export function toAbsoluteHttpsUrl(input: string): string {
  if (!input) return ''

  const url = input.trim()

  // If already starts with http or https, force https
  if (/^https?:\/\//i.test(url)) {
    return url.replace(/^http:\/\//i, 'https://')
  }

  // If it starts with //example.com → prepend https:
  if (url.startsWith('//')) {
    return `https:${url}`
  }

  // Otherwise, assume it's a bare domain → add https://
  return `https://${url}`
}

export function getFileCategory(
  fileType?: string | null,
  filename?: string,
): 'image' | 'video' | 'audio' | 'pdf' | 'text' | 'other' {
  // 1️⃣ Check MIME type first
  const mimeType = fileType ?? ''
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType.startsWith('video/')) return 'video'
  if (mimeType.startsWith('audio/')) return 'audio'
  if (mimeType === 'application/pdf') return 'pdf'
  if (['text/plain', 'application/json', 'text/csv'].includes(mimeType)) return 'text'

  // 2️⃣ Fallback: check filename extension if provided
  if (filename) {
    const extMatch = filename.match(/\.([a-z0-9]+)$/i)
    if (extMatch) {
      const ext = extMatch[1].toLowerCase()
      if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) return 'image'
      if (['mp4', 'mov', 'avi', 'webm', 'mkv', 'm4v'].includes(ext)) return 'video'
      if (['mp3', 'wav', 'aac', 'ogg', 'm4a', 'flac'].includes(ext)) return 'audio'
      if (ext === 'pdf') return 'pdf'
      if (['txt', 'log', 'json', 'csv'].includes(ext)) return 'text'
    }
  }

  // 3️⃣ Default fallback
  return 'other'
}

export function getNameInitials(name?: string | null) {
  if (!name) return ''
  return (
    name
      .match(/(\b\S)?/g)
      ?.join('')
      ?.match(/(^\S|\S$)?/g)
      ?.join('')
      ?.toUpperCase() || ''
  )
}

export const openNewWindow = async (url: string, windowSize = 600) => {
  await navigateTo(url, {
    external: true,
    open: {
      target: '_blank',
      windowFeatures: {
        width: windowSize,
        height: windowSize,
      },
    },
  })
}

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const formatFileSize = (size: number) => {
  if (size < 1024) {
    return `${size} bytes`
  }
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`
  }
  return `${(size / 1024 / 1024).toFixed(2)} MB`
}
export const getPayloadSizeInBytes = (payload: unknown) => {
  const json = JSON.stringify(payload)
  return new Blob([json]).size
}

export const autoScrollInvalidFieldsIntoView = () => {
  const invalidFields = document.querySelectorAll('[aria-invalid="true"]')
  const basicInlineError = document.getElementById('basic-inline-error')
  if (invalidFields.length > 0) {
    const firstInvalidField = invalidFields[0] as HTMLElement
    if (firstInvalidField) {
      firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' })
      // firstInvalidField?.focus()
    }
  }
  if (basicInlineError) {
    basicInlineError.scrollIntoView({ behavior: 'smooth', block: 'center' })
    return
  }
}
